<template>
    <h1 class="mx-0">
        {{ title }}
        <!-- For debugging in CI -->
        <RedirectToApp
            :ciUrl="`/apps/business/template/view/${$route.params.id}?forceci=true`"
        />
    </h1>
</template>

<script>
import TEMPLATES from "@/constants/templates";
import { findKey } from "lodash";
import RedirectToApp from "@/components/commons/redirect-to-app.vue";

export default {
    components: {
        RedirectToApp
    },
    props: {
        title: {
            type: String,
            required: true
        }
    },
    computed: {
        templateTypeId() {
            return Number(
                findKey(TEMPLATES.LIST, {
                    route: String(this.$route.params.type)
                })
            );
        },
        isUsingViewPage() {
            return TEMPLATES.IN_VIEW.includes(this.templateTypeId);
        }
    }
};
</script>
